import ContentItemCarousel from '@ui-components/ContentItemCarousel';
import { PlaceHolder } from '@ui-components/PlaceHolder';
import { ContentItemFragment } from 'app/graphql/__generated__/types/contento';
import { CardType, OnItemClickType } from 'app/ui-components/ContentList/ContentList';
import { OnItemImpressionType } from 'app/utils/useTrackImpression';
import React from 'react';
import { Heading, StyledRecommendations } from './Recommendations.styles';

const RecommendationsContainer = ({
    header,
    className,
    children,
}: {
    header: string;
    className?: string;
    children: JSX.Element;
}) => (
    <StyledRecommendations className={className} data-helix-type="list" aria-label={header || 'Tips för dig'}>
        <Heading as="h2">{header || 'Tips för dig'}</Heading>
        {children}
    </StyledRecommendations>
);

export const Loading = ({ className, header }: { header: string; className?: string }) => (
    <RecommendationsContainer className={className} header={header}>
        <PlaceHolder nrOfItems={6} />
    </RecommendationsContainer>
);

type RecommendationsProps = {
    items: Array<ContentItemFragment>;
    header: string;
    className?: string;
    onItemClick: OnItemClickType;
    onItemImpression: OnItemImpressionType;
};

const Recommendations = ({
    items,
    header,
    className,
    onItemClick,
    onItemImpression,
}: RecommendationsProps) => {
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <RecommendationsContainer header={header} className={className}>
            <ContentItemCarousel
                id="not-found-recommendations"
                items={items}
                editModeActivated={false}
                onItemClick={onItemClick}
                onItemImpression={onItemImpression}
                cardType={CardType.SHOWCASE}
            />
        </RecommendationsContainer>
    );
};

export default Recommendations;
